export default __webpack_public_path__ + "static/media/ic_algeria.a650dd6c.svg";